import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react"; // 🆕 ADD THIS
import "antd/dist/antd.css";
import "./App.css";
import "./styles/designSystem.css"; // Global Design System
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useAppDispatch, useAppSelector } from "./hooks/hooks"; // Add Redux hooks
import { restoreBlobUrls } from "./store/slices/mediaSlice"; // Add media cache restore
import PageContainer from "./components/PageContainer"; // 🆕 ADD THIS
import TrialWelcomeModal from "./components/TrialWelcomeModal"; // Trial welcome modal
import Content from "./views/content/content";
import ContentDetail from "./views/content/contentDetails";
import Dashboard from "./views/dashboard/dashboard";
import FollowUps from "./views/followUps/followUps";
import Leads from "./views/leads/leads";
import Login from "./views/login";
import LoginController from "./views/login/LoginController";
import TestMpinSetup from "./views/login/TestMpinSetup";
import PostLoginMpinSetup from "./views/login/PostLoginMpinSetup";
import { useAnalytics } from "./hooks/useAnalytics";
import { trackUserAction } from "./config/firebase";
import { OtpVerification } from "./views/otpVerification";
import LeadDistribution from './views/settings/leaddistribution';
import Signup from "./views/signup/signup";
import PrivateRoute from "./routes/privateRoute";
import Automation from "./views/automation/automation";
import WhatsappInbox from "./views/whatsappInbox/whatsappinbox";
import WhatsappBroadcast from "./views/whatsappBroadcast/whatsappbroadcast";
import CreateWhatsappBroadcast from "./views/createWhatsappBroadcast/createWhatsappBroadcast";
import SimpleFormContainer from "./views/userForm/SimpleFormContainer";
import WebForm from "./views/webForm/webForm";
import Test from "./views/webForm/Test";
import Template from "./views/template";
import Profile from "./views/profile";
import SubscriptionPage from './views/Subscription/SubscriptionPage';
import { Toaster } from "react-hot-toast";
import Integrations from "./views/integrations/integrations";
import "./ag-grid-theme-builder.css";
import Modal from "react-modal";
import ActivityFeed from "./views/ActivityFeed/ActivityFeed";
import CallLogsScreen from "./components/CallLogsScreen";
import CallLogsDrawer from "./components/CallLogsDrawer";
import ActivityFeedDrawer from "./views/ActivityFeed/ActivityFeedDrawer";
import NotificationComponent from "./components/NotificationComponent";
import SettingsContainer from "./views/settings/SettingsContainer";
import InvoiceList from "./views/Invoice/InvoiceList";
import ProductList from "./views/products/productsList";
import QuotationList from "./views/Quotation/QuotationList";
import SubscriptionExpiredPage from './views/login/SubscriptionExpiredPage'
import BotContainer from "./views/bots/BotContainer";
import logger from "./utils/logger";

import CustomizationContainer from "./views/Customization/CustomizationContainer";
import TeamsManagement from "./views/teams/TeamsManagement";
import SettingsPage from "./views/settings/SettingsPage";

// Report components removed - now using tabbed interface within dashboard

// Add wherever the main app component renders
logger.log("🌍 APP LEVEL - Route Context:", {
  timestamp: new Date().toISOString(),
  currentPath: window.location.pathname,
  authToken: localStorage.getItem("auth_token") ? 'EXISTS' : 'MISSING',
  userData: localStorage.getItem("userData") ? 'EXISTS' : 'MISSING',
  userPreferences: localStorage.getItem("user_preferences") ? 'EXISTS' : 'MISSING'
});

// 🏢 BUSINESS DATA CONSOLE LOGS
try {
  const userBusinesses = JSON.parse(localStorage.getItem('userBusinesses') || '[]');
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userPreferences = JSON.parse(localStorage.getItem('user_preferences') || '{}');

 

  if (userBusinesses.length > 0) {
    logger.log('📋 Available Businesses:');
    userBusinesses.forEach((business: any, index: number) => {
      logger.log(`  ${index + 1}. ${business.firstName} ${business.lastName} - ${business.organization?.name} (${business.organization?._id})`);
    });
  } else {
    console.warn('⚠️ No businesses found in localStorage.userBusinesses');
  }

  
} catch (error) {
  console.error('❌ Error parsing business data:', error);
}

// Set Modal Root Element
Modal.setAppElement("#root");

// Use a single googleClientId definition
const googleClientId =
  "322938904388-p7l4fso2n9g93n8irg3c9get69rn3vk4.apps.googleusercontent.com";

// 🆕 CORRECTED Route Component
const RouteComponent = () => {
  useAnalytics();
  const location = useLocation();

  // Console logging for debugging
  useEffect(() => {
    
    logger.log('📍 Navigated to:', location.pathname);
    logger.log('⏰ Time:', new Date().toISOString());

  }, [location.pathname]);

  return (
    <>
      {/* 🆕 PERSISTENT PAGES - OUTSIDE Routes */}
      <PageContainer pagePath="/leads">
        <PrivateRoute>
          <Leads />
        </PrivateRoute>
      </PageContainer>

      <PageContainer
        pagePath="/dashboard"
        onReactivate={() => {
          logger.log("🔄 Dashboard page reactivated");
        }}
      >
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/tasks">
        <PrivateRoute>
          <FollowUps />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/content">
        <PrivateRoute>
          <Content />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/InvoiceList">
        <PrivateRoute>
          <InvoiceList />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/invoicelist">
        <PrivateRoute>
          <InvoiceList />
        </PrivateRoute>
      </PageContainer>

      <PageContainer
        pagePath="/QuotationList"
        onReactivate={() => {
          logger.log("🔄 QuotationList (uppercase) page reactivated");
        }}
      >
        <PrivateRoute>
          <QuotationList />
        </PrivateRoute>
      </PageContainer>

      <PageContainer
        pagePath="/quotationlist"
        onReactivate={() => {
          logger.log("🔄 quotationlist (lowercase) page reactivated");
        }}
      >
        <PrivateRoute>
          <QuotationList />
        </PrivateRoute>
      </PageContainer>

      <PageContainer
        pagePath="/Quotationlist"
        onReactivate={() => {
          logger.log("🔄 Quotationlist (mixed case) page reactivated");
        }}
      >
        <PrivateRoute>
          <QuotationList />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/products">
        <PrivateRoute>
          <ProductList />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/whatsappBroadcast">
        <PrivateRoute>
          <WhatsappBroadcast />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/automation">
        <PrivateRoute>
          <Automation />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/template">
        <PrivateRoute>
          <Template />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/Auto-reply-bots">
        <PrivateRoute>
          <BotContainer />
        </PrivateRoute>
      </PageContainer>


      <PageContainer pagePath="/form/">
        <PrivateRoute>
          <SimpleFormContainer />
        </PrivateRoute>
      </PageContainer>

      <PageContainer pagePath="/form">
        <PrivateRoute>
          <SimpleFormContainer />
        </PrivateRoute>
      </PageContainer>

      {/* Settings routes moved to Routes below with nested routing */}

      {/* 🔄 TRADITIONAL ROUTES - INSIDE Routes */}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LoginController />} />
        <Route path="/otp-verify" element={<OtpVerification />} />
        <Route path="/mpin-setup" element={<PostLoginMpinSetup />} />
        <Route path="/sign-up" element={<Signup />} />
        <Route path="/form/:_id" element={<WebForm />} />
        <Route path="/test" element={<Test />} />
        <Route path="/test-mpin" element={<TestMpinSetup />} />

      

        {/* 🚨 LEADS, TASKS, CONTENT, AUTOMATION ROUTES REMOVED - Now handled by PageContainer above */}
        <Route
          path="/get-details/:_id"
          element={
            <PrivateRoute>
              <ContentDetail />
            </PrivateRoute>
          }
        />
        {/* 🚨 WHATSAPP INBOX ROUTE REMOVED - Now handled by PageContainer above */}
        {/* 🚨 WHATSAPP BROADCAST ROUTE REMOVED - Now handled by PageContainer above */}
        <Route
          path="/createWhatsappBroadcast"
          element={
            <PrivateRoute>
              <CreateWhatsappBroadcast />
            </PrivateRoute>
          }
        />
        <Route
          path="/editWhatsappBroadcast/:id"
          element={
            <PrivateRoute>
              <CreateWhatsappBroadcast />
            </PrivateRoute>
          }
        />
        {/* 🚨 TEMPLATE ROUTE REMOVED - Now handled by PageContainer above */}
        {/* 🚨 FORM ROUTE REMOVED - Now handled by PageContainer above */}
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
         

 <Route
          path="/customization/"
          element={
            <PrivateRoute>
              <CustomizationContainer  />
            </PrivateRoute>
          }
        />

        <Route
          path="/integrations/"
          element={
            <PrivateRoute>
              <Integrations />
            </PrivateRoute>
          }
        />
        <Route
          path="/activity-feed"
          element={
            <PrivateRoute>
              <ActivityFeed />
            </PrivateRoute>
          }
        />
        {/* 🚨 PRODUCTS, INVOICE, QUOTATION ROUTES REMOVED - Now handled by PageContainer above */}

        {/* Unified Settings Page */}
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings/*"
          element={
            <PrivateRoute>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        {/* 🚨 AUTO-REPLY-BOTS ROUTE REMOVED - Now handled by PageContainer above */}
        <Route
          path="/SubscriptionExpiredPage"
          element={<SubscriptionExpiredPage/>}
        />
        <Route
          path="/call-logs"
          element={
            <PrivateRoute>
              <CallLogsScreen />
            </PrivateRoute>
          }
        />

        {/* Report routes removed - now using tabbed interface within dashboard */}

        {/* WhatsApp Inbox routes - using normal routing for real-time features */}
        <Route
          path="/whatsappInbox"
          element={
            <PrivateRoute>
              <WhatsappInbox />
            </PrivateRoute>
          }
        />
        <Route
          path="/WhatsappInbox"
          element={
            <PrivateRoute>
              <WhatsappInbox />
            </PrivateRoute>
          }
        />
        <Route
          path="/whatsappinbox"
          element={
            <PrivateRoute>
              <WhatsappInbox />
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

// Keep your existing App component EXACTLY the same
const App = () => {
  const dispatch = useAppDispatch();
  const [showTrialModal, setShowTrialModal] = useState(false);
  const location = useLocation(); // Track location changes

  // 🏢 ACCESS REDUX STATE FOR BUSINESS DATA
  const reduxState = useAppSelector((state) => state);
  const userState = useAppSelector((state) => state?.whatsapp?.user);

  // Restore blob URLs from persisted base64 data on app initialization
  useEffect(() => {
    logger.log("🔄 Restoring media cache blob URLs from persisted data");
    dispatch(restoreBlobUrls());
  }, [dispatch]);

  // Check for new signup and show trial welcome modal - runs on every route change
  useEffect(() => {
    const shouldShowTrialModal = localStorage.getItem("show_trial_welcome_modal");
    if (shouldShowTrialModal === "true") {
      logger.log("✨ New signup detected - showing trial welcome modal");
      setShowTrialModal(true);
      // Clear the flag so modal doesn't show again
      localStorage.removeItem("show_trial_welcome_modal");
    }
  }, [location.pathname]); // Re-check when route changes

  // 🏢 REDUX STORE BUSINESS DATA CHECK - runs when state changes
  useEffect(() => {
    logger.log('🔗 Full Redux State:', reduxState);
    logger.log('👤 User Slice:', userState);
    logger.log('🏢 Current User from Redux:', userState?.currentUser);
    logger.log('🔌 User Integrations:', userState?.userIntegrations);
    logger.log('💬 WhatsApp Integration:', userState?.whatsappIntegration);
    logger.log('✅ Is WhatsApp Integrated:', userState?.isWhatsappIntegrated);
    logger.log('👥 Team Members:', userState?.teamMembers);
  }, [reduxState, userState]);

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <NotificationComponent />
      <RouteComponent />
      <CallLogsDrawer />
      <ActivityFeedDrawer />
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
        }}
      />
      <TrialWelcomeModal
        visible={showTrialModal}
        onClose={() => setShowTrialModal(false)}
      />
    </GoogleOAuthProvider>
  );
};

export default App;